import { api } from "./api";
// Staff Api's
export const VerifyStaffId = async (addUrl = "") => {
  return await api.get(`staff/v2/verify/registration/no?${addUrl}`);
};
export const StaffList = async (addUrl = "") => {
  return await api.get(`staff/v2/list?${addUrl}`);
};

export const StaffSinglePresent = async (payload) => {
  return await api.post(`staff/v2/attendance/post`, payload);
};
export const todayStaffAttendance = async (addUrl = "") => {
  return await api.get(`staff/v2/attendance/today?${addUrl}`);
};

export const addStaff = async (data) => {
  return await api.post("staff/v2/add", data);
};

export const StaffUpdates = async (data) => {
  return await api.post("staff/v2/update", data);
};

export const updateStaffStatus = async (id) => {
  return await api.post("staff/v2/status", { id });
};

export const deleteStaff = async (id) => {
  return await api.post("staff/v2/delete", { id });
};

export const staffDetails = async (id) => {
  return await api.get(`staff/v2/details?id=${id}`);
};

export const staffPasswordUpdate = async (data) => {
  return await api.post("staff/v2/change-password", data);
};

export const terminateStaff = async (data) => {
  return await api.post(`staff/v2/terminate`, data);
};
export const rejoinStaff = async (data) => {
  return await api.post(`/staff/v2/rejoin`, data);
};
export const salaryUpdate = async (data) => {
  return api.post(`staff/v2/salary/update`, data);
};
export const EmploymentAdd = async (data) => {
  return api.post(`staff/v2/salary/employment/add`, data);
};
export const EmploymentRevision = async (data) => {
  return api.post(`staff/v2/employment/revise`, data);
};
export const addMonthSalary = async (data) => {
  return api.post(`staff/v2/month/salary/add`, data);
};

export const salaryPayDetails = async (addUrl = "") =>
  api.get(`staff/v2/salary/pay/details/v2?${addUrl}`);

export const staffSalaryPay = async (data) =>
  api.post(`staff/v2/salary/pay/v2`, data);

export const staffReportSummary = (addUrl = "") =>
  api.get(`staff/v2/report/summary?${addUrl}`);

export const staffReportDetail = (addUrl = "") =>
  api.get(`staff/v2/report/detail?${addUrl}`);

// Working Schedule

export const workingSchedulesList = async (addUrl = "") => {
  return await api.get(`staff/v2/working/schedules?${addUrl}`);
};

export const addWorkingSchedule = async (data) => {
  return await api.post("staff/v2/working/schedule/add", data);
};

export const updateWorkingSchedule = async (data) => {
  return await api.post("staff/v2/working/schedule/update", data);
};

export const updateWorkingScheduleStatus = async (id) => {
  return await api.post("staff/v2/working/schedule/status", { id });
};

export const deleteWorkingSchedule = async (id) => {
  return await api.post("staff/v2/working/schedule/delete", { id });
};

export const monthlyAttendance = async (addUrl = "") => {
  return await api.get(`staff/v2/attendance/month/list?${addUrl}`);
};

export const StaffsendPresentMsg = async (data) => {
  return await api.post("staff/v2/send/present/msg", data);
};

export const StaffsendAbsentMsg = async (data) => {
  return await api.post("staff/v2/send-absent-msg", data);
};

// Work Report

export const staffWorkReportHistory = async (addUrl = "") => {
  return await api.get(`work-report/admin-history?${addUrl}`);
};
export const workReportList = async (addUrl = "") => {
  return await api.get(`work-report/list?${addUrl}`);
};

export const workReportTrackingDashboard = async (addUrl = "") => {
  return await api.get(`work-report/tracking-dashboard?${addUrl}`);
};

export const updateStaffEarnedSalary = async (data) => {
  return await api.post("staff/v2/update/earned/salary", data);
};

export const salaryGeneratePreview = async (data) => {
  return await api.post("staff/v2/salary/generate/preview", data);
};

export const salaryGenerateSave = async (data) => {
  return await api.post("staff/v2/salary/generate/save", data);
};

export const salaryPreviewByDate = async (data) => {
  return await api.post("staff/v2/salary/preview/date", data);
};

export const markStaffAsDeleted = async (data) => {
  return await api.post("staff/mark/as/deleted", data);
};

export const salaryPreviewByMonth = async (data) => {
  return await api.post("staff/v2/salary/preview/by/month", data);
};

export const salaryGeneratedUpdate = async (data) => {
  return await api.post("staff/salary/generated/update", data);
};

// ================================================================
// GENERATED SALARY - REGENERATE
// ================================================================
export const salaryGeneratedRegenerate = async (data) => {
  return await api.post("staff/salary/generated/regenerate", data);
};

export const staffSalaryBulkPay = async (data) => {
  return await api.post("staff/salary/bulk-pay", data);
};

export const getAvailableStaffMenus = async () => {
  return await api.get("staff/available-menus");
};
